import { Box } from "../box/Box";
import { RecursiveCSS } from "../theme/GlobalTheme";

export const Tile = ({ children, sx, onClick }: { children: any; sx?: RecursiveCSS; onClick?: () => void }) => {
	return (
		<Box
			sx={{
				backgroundColor: "panelBackgroundPrimary",
				borderRadius: "6px",
				padding: "20px",
				borderBottom: "1px solid rgba(0, 0, 0, .1)",
				...sx,
			}}
			onClick={onClick}>
			{children}
		</Box>
	);
};
